import { TypeBookAction } from '../../../bookings/dto';

export const PERFORMED_ACTION_MESSAGES: Record<TypeBookAction, string> = {
  approve: 'Информация о подтверждении заявки получена',
  correct: 'Информация о корректировке заявки получена',
  reject: 'Информация об отказе от заявки получена',
};
